import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Currency } from './currency';

export class BankNote extends BaseEntity{

    bankNoteCode    : string;
    currency        : Currency;
    name            : string;
    theValue        : number;
    rank            : number;

    
    //Transient
    theNumber       : number;

}